import {Trans} from 'react-i18next'
import styled from '@emotion/styled'
import messages from '../../../../assets/messages'

const Container = styled.section`
  background: #FFFFFF;
  border: 1px solid #E5E7EE;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  padding: 1.5rem;
`

const Title = styled.h2`
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
`

const Step = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 2rem 1fr;
`

const Numeral = styled.div`
  align-items: center;
  background: #F2F4F8;
  border-radius: 999px;
  color: #1C212E;
  display: flex;
  font-family: Roboto;
  font-weight: 600;
  height: 2rem;
  justify-content: center;
  width: 2rem;
`

const StepBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

const StepTitle = styled.div`
  color: #1C212E;
  font-family: Roboto;
  font-size: 0.9375rem;
  font-weight: 600;
`

const StepDescription = styled.div`
  color: #73738C;
  font-family: Roboto;
  font-size: 0.875rem;
`

/**
 * Three-step explainer rendered alongside the offer details (PT-5354).
 * Reassures the investor that "Invest" creates a sub-account but moves no
 * money, addressing the friction the bare password form caused.
 */
export const WhatHappensNext = () => (
  <Container>
    <Title>
      <Trans {...messages.pammOfferWhatHappensTitle} />
    </Title>
    <Step>
      <Numeral>1</Numeral>
      <StepBody>
        <StepTitle>
          <Trans {...messages.pammOfferWhatHappensStep1Title} />
        </StepTitle>
        <StepDescription>
          <Trans {...messages.pammOfferWhatHappensStep1Body} />
        </StepDescription>
      </StepBody>
    </Step>
    <Step>
      <Numeral>2</Numeral>
      <StepBody>
        <StepTitle>
          <Trans {...messages.pammOfferWhatHappensStep2Title} />
        </StepTitle>
        <StepDescription>
          <Trans {...messages.pammOfferWhatHappensStep2Body} />
        </StepDescription>
      </StepBody>
    </Step>
    <Step>
      <Numeral>3</Numeral>
      <StepBody>
        <StepTitle>
          <Trans {...messages.pammOfferWhatHappensStep3Title} />
        </StepTitle>
        <StepDescription>
          <Trans {...messages.pammOfferWhatHappensStep3Body} />
        </StepDescription>
      </StepBody>
    </Step>
  </Container>
)
